import React, { useState } from "react";
import { Box, Container, ImageList, ImageListItem, Typography } from "@mui/material";
import { ImageLightboxModal } from "./ImageLightboxModal";

export const Galeria = () => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const itemData = [
    { img: '/galeria2026/202609_1.webp', title: 'Terapeuta de masaje profesional Hua Hao Yue Yuan' },
    { img: '/galeria2026/202609_2.webp', title: 'Masajista profesional en Barcelona' },
    { img: '/galeria2026/202609_3.webp', title: 'Terapeuta de masaje oriental en Barcelona' },
    { img: '/galeria2026/202609_4.webp', title: 'Especialista en masaje relajante y descontracturante' },
    { img: '/galeria2026/202609_5.webp', title: 'Masajista experta en técnicas tradicionales' },
    { img: '/galeria2026/202609_6.webp', title: 'Masajistas profesionales en Barcelona' },
    { img: '/galeria2026/202609_7.webp', title: 'Equipo de terapeutas orientales en Barcelona' },
    { img: '/galeria2026/202609_8.webp', title: 'Terapeuta especializada en bienestar y relajación' },
    { img: '/galeria2026/202609_9.webp', title: 'Masajistas del centro Hua Hao Yue Yuan' },
    { img: '/galeria2026/202609_10.webp', title: 'Terapeuta en masajes relajantes tradicionales' },
    { img: '/galeria2026/202609_11.webp', title: 'Especialistas en masajes tradicionales chinos' },
    { img: '/galeria2026/202609_12.webp', title: 'Masajistas en Barcelona Eixample' },
    { img: '/galeria2026/202609_13.webp', title: 'Terapeutas de masaje oriental en Carrer València' },
  ];

  const handleOpen = (index: number) => {
    setSelectedIndex(index);
    setOpenModal(true);
  };

  return (
    <section id="galeria">
      <Container sx={{ py: { xs: 5, md: 7 } }}>
        <Box sx={{ maxWidth: "760px", mx: "auto", textAlign: "center", mb: 4.5 }}>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              px: 2,
              py: 0.6,
              borderRadius: "30px",
              backgroundColor: "rgba(212, 175, 55, 0.1)",
              border: "1px solid rgba(212, 175, 55, 0.25)",
              color: "#9E7736",
              fontSize: "0.75rem",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              mb: 2,
            }}
          >
            <span>✦</span> Nuestro Equipo
          </Box>
          <Typography
            variant="h2"
            sx={{
              mb: 1.5,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              color: "#1C1612",
              fontWeight: 700,
              fontSize: { xs: "1.85rem", md: "2.35rem" },
              letterSpacing: "-0.02em",
            }}
          >
            Nuestras Masajistas
          </Typography>
          <Typography variant="body1" sx={{ color: "#68594F", fontSize: "0.95rem", lineHeight: 1.7 }}>
            Nuestras talentosas masajistas te guiarán hacia un estado de plenitud, fusionando la gracia de sus movimientos con la profesionalidad que define nuestra experiencia única en masajes.
          </Typography>
        </Box>

        <ImageList
          variant="masonry"
          sx={{
            columnCount: {
              xs: '2 !important',
              sm: '2 !important',
              md: '3 !important',
              lg: '4 !important',
            },
            gap: 16,
          }}
        >
          {itemData.map((item, index) => (
            <ImageListItem
              key={item.img}
              onClick={() => handleOpen(index)}
              sx={{
                overflow: "hidden",
                borderRadius: "16px",
                cursor: "pointer",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px) scale(1.02)",
                  "& img": {
                    boxShadow: "0 12px 24px rgba(160, 122, 52, 0.2)",
                  },
                },
              }}
            >
              <img
                src={item.img}
                alt={item.title}
                style={{
                  borderRadius: "16px",
                  border: "1px solid #EEDFC6",
                  boxShadow: "0 4px 14px rgba(160, 122, 52, 0.08)",
                  display: "block",
                  width: "100%",
                  transition: "box-shadow 0.3s ease",
                }}
                loading="lazy"
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Container>

      <ImageLightboxModal
        open={openModal}
        currentIndex={selectedIndex}
        items={itemData}
        onClose={() => setOpenModal(false)}
        onNavigate={(newIndex) => setSelectedIndex(newIndex)}
      />
    </section>
  );
};